// For image upload - treat the delimiters of -, _, and . the same.
const parseFileName = fileName => fileName
  .replace('-', '.')
  .replace('_', '.')
  // Remove all 0's from the beginning of the filename
  .replace(/^0+/, '')
  .toUpperCase();

export default parseFileName;
